export enum ErrorHeaderTitleEnum {
  InvalidRequest = 'Invalid Request',
  Unauthorized = 'Unauthorized',
  ResourceNotFound = 'Resource Not Found',
  Conflict = 'Conflict',
  Timeout = 'Timeout',
  Sorry = 'Sorry'
}
